export type Colors =
  | 'primary-1'
  | 'background-1'
  | 'background-2'
  | 'background-3'
  | 'background-4'
  | 'text-1'
  | 'text-2'
  | 'text-3'
  | 'green'
  | 'success'
  | 'error'
  | 'warning';

export type TypographyTypes =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'p1'
  | 'p2'
  | 'p3'
  | 'p4'
  | 'p5';
export type TypographyWeights = 'bold' | 'normal' | 'lighter';
export enum Speeds {
  FAST = 150,
  NORMAL = 200,
  SLOW = 250,
}
